import { Http } from './http';
import { User } from '@types';

class ManagerHttp extends Http {
  prefix = 'manager';

  async loginAdmin(userId: number): Promise<string> {
    const res = await this.get<string>(`/${userId}/login-admin`);

    return res.data;
  }

  async getFarmers(managerId: number): Promise<[User[], number]> {
    const res = await this.get<[User[], number]>(`/${managerId}/get-farmers`);

    return res.data;
  }

  async removeFarmers(managerId: number, ids: number[]): Promise<number> {
    const res = await this.delete<number>(`/${managerId}/remove-farmers`, { ids });

    return res.data;
  }
}

export const managerHttp = new ManagerHttp();
